import {Request} from "kaiju.core";

const applicationRootLoader = async (props: any) => {
    const data = await Request('ApplicationGui.get', {id: props.params.appId}).then((resp: any) => {
        return resp.result
    })
    return data
};

export {applicationRootLoader};